const checkUndefinedableValue = v => v !== undefined;

export default checkUndefinedableValue;
